'use strict';

//var tablesort = require('tablesort');
var configMenuHandler = {};

configMenuHandler.init = function (props, environment) {
	//console.log('init config menu :',props );

	configMenuHandler.data = props.data;
	configMenuHandler.onColumnConfigUpdate = props.onColumnConfigUpdate;
	configMenuHandler.environment = environment;

	configMenuHandler.columnsToUpdate = {};

	configMenuHandler.el = document.getElementById('config-menu');

	configMenuHandler.columnsTable = configMenuHandler.el.querySelector("table");

	//configMenuHandler.updateTable();
	//$('input[type=checkbox]').ptCheckBox();
	//console.log($('input[type=checkbox]').ptCheckBox());
};

configMenuHandler.updateTable = function () {

	var sortOrder = 'descending';

	var tableData = [];
	_.each(configMenuHandler.data.columns, function (d) {
		var row = {
			'Column': { 'label': d.header },
			'Active': { 'checked': d.active, id: d.column.id }
		};

		if (!d.exclude) tableData.push(row);
	});

	var headerData = Object.keys(tableData[0]);

	generateTable();
	generateTableHead();

	function generateTableHead() {
		var thead = configMenuHandler.columnsTable.createTHead();
		var row = thead.insertRow();

		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = headerData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var _key = _step.value;

				var th = document.createElement("th");
				th.setAttribute('data-sort-method', 'thead');

				//th.onclick = function (event) { sortTable(event) };
				var text = document.createTextNode(_key);
				th.appendChild(text);
				row.appendChild(th);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}

	function generateTable() {
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = tableData[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var element = _step2.value;

				var row = configMenuHandler.columnsTable.insertRow();
				for (key in element) {
					var cell = row.insertCell();

					var innerHTML = void 0;
					if (key === 'Active') {
						if (element[key].checked) {
							row.style.backgroundColor = '#E5EEF2';
							row.style.color = '#396198';
						}
						cell.style.paddingLeft = '24px';
						innerHTML = document.createElement("input");
						innerHTML.className = 'checkbox';
						innerHTML.setAttribute('type', 'checkbox');
						innerHTML.setAttribute('id', element[key].id);
						innerHTML.setAttribute('name', element[key].id);
						innerHTML.checked = element[key].checked;
						innerHTML.onclick = function (event) {
							onCheckMarkChange(event);
						};
					} else {
						innerHTML = document.createTextNode(element[key].label);
					}

					cell.appendChild(innerHTML);
				}
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		if (configMenuHandler.environment !== 'ISPM') {
			$('input[type=checkbox]').ptCheckBox();
			//$('span[type=rdRadioButtonGroup]').ptRadioToggleButtonList();
		};
	}

	//tablesort(document.getElementById('columns-table'), { descending: true })

	function onCheckMarkChange(event) {
		configMenuHandler.columnsToUpdate[event.target.id] = { active: event.target.checked };
	}

	function sortTable(event) {
		console.log('sort :');
	}
};

configMenuHandler.onColumnsSearch = function (event) {

	var input, filter, ul, li, a, i, txtValue;
	input = event.target.value;
	filter = event.target.value.toUpperCase();
};

configMenuHandler.onOpen = function () {

	if (configMenuHandler.el.style.visibility === 'visible') return;

	configMenuHandler.columnsToUpdate = {};
	configMenuHandler.columnsTable.innerHTML = "";

	configMenuHandler.updateTable();
	configMenuHandler.el.style.visibility = 'visible';
};

configMenuHandler.onClose = function () {
	configMenuHandler.el.style.visibility = 'hidden';
};

configMenuHandler.onSave = function (event) {

	configMenuHandler.el.style.visibility = 'hidden';
	var updatePlot = false;

	_.each(configMenuHandler.data.columns, function (c) {
		if (configMenuHandler.columnsToUpdate[c.column.id]) {
			c.active = configMenuHandler.columnsToUpdate[c.column.id].active;
			updatePlot = true;
		}
	});
	if (updatePlot) configMenuHandler.onColumnConfigUpdate(configMenuHandler.data.columns);
};

module.exports = configMenuHandler;